import {
  SessionStatus,
  HostStatus,
  type HostStatusChangedPayload,
  type SessionStatusChangedPayload,
} from './types'
import { LIVE_SESSION_STATUSES } from '@/infra'

const VALID_SESSION_STATUSES: readonly string[] = Object.values(SessionStatus)
const VALID_HOST_STATUSES: readonly string[] = Object.values(HostStatus)

export function isSessionStatusChangedPayload(obj: unknown): obj is SessionStatusChangedPayload {
  if (typeof obj !== 'object' || obj === null) return false
  const candidate = obj as Record<string, unknown>

  return (
    typeof candidate['userExternalId'] === 'string' &&
    typeof candidate['claudeSessionId'] === 'string' &&
    typeof candidate['status'] === 'string' &&
    VALID_SESSION_STATUSES.includes(candidate['status']) &&
    (candidate['previousStatus'] === null ||
      candidate['previousStatus'] === undefined ||
      (typeof candidate['previousStatus'] === 'string' &&
        VALID_SESSION_STATUSES.includes(candidate['previousStatus'])))
  )
}

export function isLiveSessionStatus(status: SessionStatus): boolean {
  return LIVE_SESSION_STATUSES.includes(status)
}

export function isHostStatusChangedPayload(obj: unknown): obj is HostStatusChangedPayload {
  if (typeof obj !== 'object' || obj === null) return false
  const candidate = obj as Record<string, unknown>

  return (
    typeof candidate['userExternalId'] === 'string' &&
    typeof candidate['hostId'] === 'string' &&
    typeof candidate['hostName'] === 'string' &&
    typeof candidate['status'] === 'string' &&
    VALID_HOST_STATUSES.includes(candidate['status']) &&
    (candidate['previousStatus'] === null ||
      candidate['previousStatus'] === undefined ||
      (typeof candidate['previousStatus'] === 'string' &&
        VALID_HOST_STATUSES.includes(candidate['previousStatus'])))
  )
}
